const uploader32 = {
    svg: '<svg style="width:2.00rem; height:2.00rem;" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15.25" stroke-width="1.5"/><path stroke-width="1.5" d="M11.147 21.371a4.853 4.853 0 1 1 9.706 0 4.853 4.853 0 0 1-9.706 0m9.617.927a4.854 4.854 0 0 1-9.528 0h-3.95V8.345h6.767l1.397 1.761h9.264v12.192zM7.381 13.332h17.333zM16 18.984v5.284"/><polyline stroke-width="1.5" points="6.8089479 13.1161714 8.94113838 10.983981 11.0733289 13.1161714" transform="translate(7.058824, 8.000000)"/></svg>',
};

export { uploader32 as default };
